module.exports = "/gp/img/error.ce8.svg";